import { ArrowRightIcon, Button, Flex, Label } from "@fluentui/react-northstar";
import { MsTeamsContext } from "msTeams/store";
import React, { useContext } from "react";
import { BasicTable, RegularText, TextTableHeader } from "shared/components";
import pl from "shared/messages/pl";
import styles from "./view360EmployeesList.module.scss";
import { Employee } from "../../models";
import { useNavigate } from "react-router-dom";
import { getLinkToEntity } from "shared/routing/pages";
import { SearchEntityTypeEnum } from "view360Card/models";

export interface View360EmployeesListProps {
    employeesList: Employee[];
    isMobile?: boolean;
}

const View360EmployeesList: React.FC<View360EmployeesListProps> = ({ employeesList, isMobile }) => {
    const msTeamsContext = useContext(MsTeamsContext);
    const navigation = useNavigate();

    const getHeaderItems = () => {
        let headerItems = [
            {
                className: styles.columnType,
                content: <TextTableHeader content={pl.view360Card.employeesList.punuId} />,
                key: "punu",
            },
            {
                content: <TextTableHeader content={pl.view360Card.employeesList.fullName} />,
                key: "fullName",
            },
            {
                content: <TextTableHeader content={pl.view360Card.employeesList.companies} />,
                key: "companies",
            },
        ];

        return headerItems;
    };

    const getCompanies = (list: string[]) => {
        return (
            <Flex gap="gap.small">
                {list.map((company) => {
                    return (
                        <Label
                            key={company}
                            styles={{
                                backgroundColor: company === "EHM" ? "#357ded" : "#0fbca4",
                                color: "white",
                            }}
                            content={company}
                        />
                    );
                })}
            </Flex>
        );
    };

    const getItems = (entity: Employee) => {
        let items = [
            {
                className: styles.columnType,
                key: `${entity.id}-punu`,
                content: <RegularText content={entity.punu} />,
            },
            {
                key: `${entity.id}-name`,
                content: <RegularText content={`${entity.lastName} ${entity.firstName}`} />,
            },
            {
                key: `${entity.id}-tenant`,
                content: getCompanies(entity.tenantCodeList),
            },
        ];

        return items;
    };

    const getMobileItems = (entity: Employee) => {
        let items = [
            {
                className: styles.columnType,
                key: `${entity.id}-punu`,
                content: <RegularText content={entity.punu} />,
            },
            {
                key: `${entity.id}-name`,
                content: <RegularText content={`${entity.lastName} ${entity.firstName}`} />,
            },
            {
                className: styles.columnAction,
                key: `${entity.id}-action`,
                content: (
                    <Button
                        size="small"
                        primary
                        iconOnly
                        icon={<ArrowRightIcon size="small" />}
                        onClick={() => {
                            navigation(getLinkToEntity(SearchEntityTypeEnum.SalesPerson, entity.id ?? 0));
                        }}
                    />
                ),
            },
        ];

        return items;
    };

    const getRows = () => {
        return employeesList.map((employee, index) => {
            return {
                className: msTeamsContext.currentMsTeamsThemeName === "default" ? styles.defaultRow : styles.darkRow,
                onClick: () => {
                    navigation(getLinkToEntity(SearchEntityTypeEnum.SalesPerson, employee.id ?? 0));
                },
                key: `${employee.punu}_${index}`,
                items: isMobile ? getMobileItems(employee) : getItems(employee),
            };
        });
    };

    return <BasicTable headerItems={!isMobile ? getHeaderItems() : undefined} rows={getRows()} />;
};

export default View360EmployeesList;
